import { render, staticRenderFns } from "./ClinicShowAvailability.vue?vue&type=template&id=195cfb87"
import script from "./ClinicShowAvailability.vue?vue&type=script&lang=js"
export * from "./ClinicShowAvailability.vue?vue&type=script&lang=js"
import style0 from "./ClinicShowAvailability.vue?vue&type=style&index=0&id=195cfb87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports